import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let noShowBookingId = useDataValue({
    viewPath: props.viewPath,
    context: 'appointment_actions',
    path: 'appointment_booking._id',
  })

  return useMemo(() => {
    if (!data) return null
    let currentBooking = data[0]?.booking?.[0]
    if (!currentBooking || currentBooking._id !== noShowBookingId) return null
    return currentBooking
  }, [data, noShowBookingId])
}
